import { WhatsAppIcon, WHATSAPP_URL } from "./SocialIcons";

const WhatsAppFAB = () => (
  <a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Falar no WhatsApp"
    className="group fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-xl"
  >
    <span className="absolute inset-0 animate-ping rounded-full bg-[#25D366] opacity-30" />
    <WhatsAppIcon size={26} />
    <span className="pointer-events-none absolute right-16 whitespace-nowrap rounded-md bg-foreground px-3 py-1.5 text-xs font-medium text-background opacity-0 transition-opacity duration-200 group-hover:opacity-100">
      Falar no WhatsApp
    </span>
  </a>
);

export default WhatsAppFAB;
